import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAccessHistory,IAccessHistoryListItem } from '../types';

let storage_key = 'accessHistory_list';
let defaultListItem = {
  hash: "",
  key: "",
  label: "nav.home",
  path: "/:lang",
  search: "",
  state: null
}
const initialState: IAccessHistory = {
  list: JSON.parse(window.localStorage.getItem(storage_key) || `${JSON.stringify([defaultListItem])}`),
  route: JSON.parse(window.localStorage.getItem(storage_key+'_route') || `{}`),
};

const accessHistorySlice = createSlice({
  name: 'accessHistory',
  initialState,
  reducers: {
    accessRouteEdit: (state, action: PayloadAction<{key:string, status: string}>) => {
      const {key,status}:{key:string,status:string} = action.payload;
      let route = Object.assign(state.route);
      if(route.hasOwnProperty(key)){
        route[key].status = status;
      }else{
        route = {...route,[key]:{status}}
      }
      state.route = route;
      localStorage.setItem(storage_key+'_route',JSON.stringify(route))
    },
    accessHistoryAdd: (state, action: PayloadAction<IAccessHistoryListItem>) => {
      state.list = [...state.list,action.payload];
      localStorage.setItem(storage_key,JSON.stringify(state.list))
    },
    accessHistoryEdit: (state, action: PayloadAction<IAccessHistoryListItem>) => {
      let list = JSON.parse(JSON.stringify([...state.list]));
      let { path} = action.payload;
      list.forEach((item:any,i:number)=>{
        if(item.path === path){
          list.splice(i,1,{...action.payload});
        }
      })
      state.list = [...list];
      localStorage.setItem(storage_key,JSON.stringify(list))
    },
    accessHistoryRemove: (state, action: PayloadAction<IAccessHistoryListItem>) => {
      let { path } = action.payload;
      let list = [...state.list].filter((item)=>{
        return item.path !== path;
      });
      state.list = [...list];
      localStorage.setItem(storage_key,JSON.stringify(list))
    },
    accessHistoryClear: (state) => {
      state.list = [];
      localStorage.setItem(storage_key,JSON.stringify([defaultListItem]))
    },
  }
});

export const { accessRouteEdit,accessHistoryAdd, accessHistoryEdit, accessHistoryRemove, accessHistoryClear} = accessHistorySlice.actions;

export default accessHistorySlice;